export default __webpack_public_path__ + "static/media/background-1.5e0dfe66.svg";